import Box from './Box';

export type { BoxProps, BaseBoxProps } from './Box';

export { Box };
export default Box;
